import { SET_CATEGORIES_STATE } from 'constants/action_types/categories'
import { CATEGORIES_BACKUP } from 'constants/categories'

export const initialState = {
  categories: CATEGORIES_BACKUP,
  loaded: false
}

function categories(state = initialState, action) {
  switch (action.type) {
    case SET_CATEGORIES_STATE:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export default categories
